import $ from "jquery";
import CONFIG from "@bd-core/config";
import GameLogic from "@bd-core/game-logic";
import {
    getCurrentRound,
    getRoundShouldEndAt,
    // getRoundStartedAt
} from "@bd-stores/game-progress";

export default class RoundTimer {
    constructor() {
        this.countdown = null;
        this.elms = {
            timer: ".js-round-countdown",
            phoneTimer: ".js-round-phone-countdown",
            progress: ".js-countdown-progress",
            nextRoundBtn: ".next-button",
        };

        this.colors = {
            white: "#ffffff",
            black: "#000000",
        };

        this.circumference = 283;
    }

    init() {
        let isPaused = false;
        const roundTimers = CONFIG.game.roundTimer;
        const roundIDs = roundTimers.map((timer) => timer.id);
        const timers = roundTimers.map((timer) => timer.timer);

        // Don't run this on static page
        if (!timers.length) return false;

        // @ts-ignore
        let index = 0;

        const runRoundTimer = async () => {
            clearInterval(this.countdown);

            // Check if there's an active round from previous session
            const currentRound = getCurrentRound();
            const roundShouldEndAt = getRoundShouldEndAt();

            // If there's an active round, find its index and check if it's still valid
            if (currentRound && roundShouldEndAt) {
                const currentIndex = roundIDs.indexOf(currentRound);
                const now = Math.floor(Date.now() / 1000);

                // If current round is still active (not expired), resume from that round
                if (currentIndex !== -1 && now < roundShouldEndAt) {
                    index = currentIndex;
                } else if (currentIndex !== -1) {
                    // Round has expired, start from next round
                    index = currentIndex + 1;
                }
            }

            if (index >= timers.length) return;

            const roundID = roundIDs[index];
            const theTimer = Number(timers[index]);

            // Check if this is a resumed round or a new round
            const isResumedRound =
                currentRound === roundID &&
                roundShouldEndAt &&
                Math.floor(Date.now() / 1000) < roundShouldEndAt;

            if (!isResumedRound) {
                // Start new round - update Firebase
                await GameLogic.handleRoundChanges(roundID, theTimer);
                GameLogic.handleUpdateRoundStatus(roundID, "started");

                // Wait a moment for the store to update
                await new Promise((resolve) => setTimeout(resolve, 100));
            }

            // Get the stored shouldEndAt value (either from resumed round or newly set)
            const shouldEndAt = getRoundShouldEndAt();

            // If no stored value, fallback to current time + timer
            const finalShouldEndAt =
                shouldEndAt || Math.floor(Date.now() / 1000) + theTimer;

            let timeLeft = finalShouldEndAt - Math.floor(Date.now() / 1000);
            let progress = (timeLeft / theTimer) * this.circumference;

            timeLeft = timeLeft > 0 ? timeLeft : 0;
            progress = progress > 0 ? progress : 0;

            $(this.elms.timer).text(timeLeft);
            $(this.elms.phoneTimer).text(timeLeft);

            $(this.elms.progress).css(
                "stroke-dashoffset",
                this.circumference - progress,
            );
            $(this.elms.progress).css("stroke", this.colors.white);
            // if parent has class mobile-view, then the stroke should be black
            if ($(".mobile-view").length) {
                $(this.elms.progress).css("stroke", this.colors.black);
            }

            this.countdown = setInterval(() => {
                timeLeft--; // Decrement by 1 each second

                if (timeLeft <= 0) {
                    isPaused = true;
                    GameLogic.handleUpdateRoundStatus(roundID, "finished");

                    $(this.elms.progress).css(
                        "stroke-dashoffset",
                        this.circumference,
                    );

                    if (Math.floor(Date.now() / 1000) === finalShouldEndAt) {
                        GameLogic.handleUpdateRoundStatus(roundID, "finished");
                    }

                    $(this.elms.timer).text('0');
                    $(this.elms.phoneTimer).text('0');

                    $(this.elms.progress).css(
                        "stroke-dashoffset",
                        this.circumference,
                    );

                    clearInterval(this.countdown);

                    // trigger next round button
                    // $(this.elms.nextRoundBtn).trigger('click');

                    // run the next round timer
                    index++;
                    runRoundTimer();
                } else {
                    isPaused = false;

                    // Recalculate progress based on current timeLeft
                    progress = (timeLeft / theTimer) * this.circumference;

                    $(this.elms.progress).css(
                        "stroke-dashoffset",
                        this.circumference - progress,
                    );
                    $(this.elms.progress).css("stroke", this.colors.white);
                }

                if ($(".mobile-view").length) {
                    $(this.elms.progress).css("stroke", this.colors.black);
                }
            }, 1000);
        };

        setTimeout(() => {
            runRoundTimer();
        }, 1500);

        const updateTimer = () => {
            const currentShouldEndAt = getRoundShouldEndAt();
            if (!currentShouldEndAt) return;
            let timeLeft = currentShouldEndAt - Math.floor(Date.now() / 1000);

            // We need to do the check again even though the code above is already checking it
            // since the code above is not guaranteed to be executed immediately
            if (timeLeft < 0) {
                timeLeft = 0;
            }

            $(this.elms.timer).text(timeLeft);
            $(this.elms.phoneTimer).text(timeLeft);
        };

        setInterval(() => {
            if (isPaused) return;

            updateTimer();
        }, 100);
    }

    stopTimer() {
        clearInterval(this.countdown);
    }
}
